import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  "class": "wp_vue_editor_wrapper"
};
var _hoisted_2 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.hasWpEditor ? (_openBlock(), _createElementBlock("textarea", {
    key: 0,
    "class": "wp_vue_editor",
    id: $props.editor_id
  }, _toDisplayString($props.modelValue), 9 /* TEXT, PROPS */, _hoisted_2)) : _withDirectives((_openBlock(), _createElementBlock("textarea", {
    key: 1,
    "class": "wp_vue_editor wp_vue_editor_plain",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.plain_content = $event;
    }),
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.updateCursorPos && $options.updateCursorPos.apply($options, arguments);
    })
  }, "        ", 512 /* NEED_PATCH */)), [[_vModelText, $data.plain_content]])]);
}